export const isValidEmail = (email: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{1,}$/.test(email)

export const ORDER_NUMBER_PREFIXES = 'A|AK|AKN'
export const ORDER_NUMBER_MIN_DIGITS = 5
export const ORDER_NUMBER_MAX_DIGITS = 9
export const ORDER_NUMBER_SUFFIX_DIGITS = 2

const orderNumberRegex = new RegExp(
  `^(${ORDER_NUMBER_PREFIXES})?[0-9-]{${ORDER_NUMBER_MIN_DIGITS},${ORDER_NUMBER_MAX_DIGITS}}$`,
)

export const isOrderNumber = (text: string) => {
  return orderNumberRegex.test(text)
}

export const cleanUpOrderNumber = (text: string) => {
  const numbers = text.replace(/[-\s]/, '').match(/[AKN0-9]{4,9}/)?.[0]
  return numbers ? `${numbers}` : null
}
